module.exports = __webpack_public_path__ + "static/media/envelope.d41d1a21.svg";